import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
  routeToDealManage as manage,
  routeToDealInterestFromHome as interest,
  routeToDealInvestFromHome as invest,
} from 'flows/routing';

import Investment from './component';

export class InvestmentContainer extends React.PureComponent {
  render() {
    return (
      <Investment {...this.props} />
    );
  }
}

InvestmentContainer.propTypes = {
  invite: PropTypes.object.isRequired,
  deal: PropTypes.object.isRequired,
  manage: PropTypes.func.isRequired,
  interest: PropTypes.func.isRequired,
  invest: PropTypes.func.isRequired,
};

export default connect(null, {manage, interest, invest})(InvestmentContainer);



// WEBPACK FOOTER //
// ./web/flows/home/components/Investment/index.js